import React from 'react';
import { Field } from 'react-final-form';
import FormSelect from 'Shared/components/FormComponents/FormSelect';

import Collapsed from '../Collapsed';

const completedFilterOptions = Object.freeze([
  { label: 'All', value: 'all' },
  { label: 'Completed', value: 'completed' },
  { label: 'Not completed', value: 'not_completed' },
]);

export default function CompletedFilter() {
  return (
    <Collapsed title="Completed">
      <Field name="completed" type="select" options={completedFilterOptions} component={FormSelect} blurInputOnSelect />
    </Collapsed>
  );
}
